module.exports = __webpack_public_path__ + "onboarding-feed-http.974f7a83b8ff62f80fb672123bc0a48d.hashedasset.svg";